module.exports = __webpack_public_path__ + "img/dne-sales.6f596432.svg";